module.exports = __webpack_public_path__ + "media/images/apparels/Dachhsund-Full-Set-hoodie.jpg";